"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v2ResponseCamelCaseTransformer = exports.v2RequestSnakeCaseTransformer = void 0;
var caseTransformers_1 = require("./caseTransformers");
var v2RequestSnakeCaseTransformer = function (data) {
    var _a;
    if (!((_a = data === null || data === void 0 ? void 0 : data.url) === null || _a === void 0 ? void 0 : _a.includes("/v2/"))) {
        return data;
    }
    if (data.data && !(data.data instanceof FormData)) {
        data.data = (0, caseTransformers_1.snakeKeys)(data.data);
    }
    if (data.params) {
        data.params = (0, caseTransformers_1.snakeKeys)(data.params);
    }
    return data;
};
exports.v2RequestSnakeCaseTransformer = v2RequestSnakeCaseTransformer;
var v2ResponseCamelCaseTransformer = function (data) {
    var _a, _b;
    if ((_b = (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.url) === null || _b === void 0 ? void 0 : _b.includes("/v2/")) {
        data.data = (0, caseTransformers_1.camelKeys)(data.data);
    }
    return data;
};
exports.v2ResponseCamelCaseTransformer = v2ResponseCamelCaseTransformer;
